import { render, staticRenderFns } from "./myTextarea.vue?vue&type=template&id=8c72c308&scoped=true"
import script from "./myTextarea.vue?vue&type=script&lang=js"
export * from "./myTextarea.vue?vue&type=script&lang=js"
import style0 from "./myTextarea.vue?vue&type=style&index=0&id=8c72c308&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c72c308",
  null
  
)

export default component.exports